import { Model } from 'modules/core/lib/mobx-rest'

export interface IFeature {
  id: string
  enabled: boolean
}

class Feature extends Model<IFeature> {
  static urlRoot() {
    return '/features'
  }
}

export default Feature
